const SITE_URL = 'https://lendingmitra.com';
const DEFAULT_IMAGE = `${SITE_URL}/logo512.png`;

const HOME_SEO = {
  title: 'Personal & Business Loans | Lending Mitra',
  description:
    'Get fast, flexible personal and business loans from Lending Mitra with a digital application, competitive rates, and minimal paperwork.',
  canonical: `${SITE_URL}/`,
  image: DEFAULT_IMAGE,
  type: 'website',
  robots: 'index,follow',
};

const SEO_BY_PATH = {
  '/': HOME_SEO,
  '/about': {
    title: 'About Lending Mitra | Simple, Transparent Lending',
    description:
      'Learn how Lending Mitra helps individuals and growing businesses access simple, transparent, and fast financial solutions.',
    canonical: `${SITE_URL}/about`,
    image: DEFAULT_IMAGE,
    type: 'website',
    robots: 'index,follow',
  },
  '/loans': {
    title: 'Business, Personal and SME Loans | Lending Mitra',
    description:
      'Explore business, personal, SME, home, property, and vehicle loan options from Lending Mitra, with flexible terms and a digital application process.',
    canonical: `${SITE_URL}/loans`,
    image: DEFAULT_IMAGE,
    type: 'website',
    robots: 'index,follow',
  },
  '/calculator': {
    title: 'EMI Calculator for Loans | Lending Mitra',
    description:
      'Calculate your monthly EMI, total interest, and repayment amount for a Lending Mitra loan using our easy online EMI calculator.',
    canonical: `${SITE_URL}/calculator`,
    image: DEFAULT_IMAGE,
    type: 'website',
    robots: 'index,follow',
  },
  '/contact': {
    title: 'Contact Lending Mitra | Loan Assistance',
    description:
      'Contact Lending Mitra for help choosing a loan, understanding eligibility, or starting your digital loan application.',
    canonical: `${SITE_URL}/contact`,
    image: DEFAULT_IMAGE,
    type: 'website',
    robots: 'index,follow',
  },
  '/coming-soon': {
    title: 'Lending Mitra',
    description: 'Explore Lending Mitra financial services.',
    canonical: `${SITE_URL}/coming-soon`,
    image: DEFAULT_IMAGE,
    type: 'website',
    robots: 'noindex,nofollow',
  },
};

export function getSeoConfig(pathname) {
  return SEO_BY_PATH[pathname] || HOME_SEO;
}

export { SITE_URL };
